import React from "react";

const Part5Form = ({ question, setQuestion, handleSubmit, loading }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Category</label>
        <select
          value={question.category}
          onChange={(e) =>
            setQuestion({ ...question, category: e.target.value })
          }
        >
          <option value="grammar">Grammar</option>
          <option value="vocabulary">Vocabulary</option>
        </select>
      </div>

      <div className="form-group">
        <label>Sub Category</label>
        <select
          value={question.subCategory}
          onChange={(e) =>
            setQuestion({ ...question, subCategory: e.target.value })
          }
        >
          {question.category === "grammar" ? (
            <>
              <option value="verb">Verb</option>
              <option value="noun">Noun</option>
              <option value="adjadv">Adjective/Adverb</option>
              <option value="pronoun">Pronoun</option>
              <option value="conjunction">Conjunction/Preposition</option>
              <option value="clause">Phrase and Clause</option>
              <option value="structure">Agreement and Structure</option>
            </>
          ) : (
            <>
              <option value="synonym">Synonym/Antonym</option>
              <option value="word_choice">Word Choice</option>
              <option value="idiom">Idiom/Expression</option>
              <option value="collocation">Collocation</option>
            </>
          )}
        </select>
      </div>

      <div className="form-group">
        <label>Question Text</label>
        <textarea
          value={question.text}
          onChange={(e) => setQuestion({ ...question, text: e.target.value })}
          placeholder="Enter question text"
        />
      </div>

      <div className="choices-container">
        {["A", "B", "C", "D"].map((choice) => (
          <div key={choice} className="choice-group">
            <label>Choice {choice}</label>
            <input
              type="text"
              value={question.choices[choice]}
              onChange={(e) =>
                setQuestion({
                  ...question,
                  choices: {
                    ...question.choices,
                    [choice]: e.target.value,
                  },
                })
              }
              placeholder={`Choice ${choice} content`}
            />
          </div>
        ))}
      </div>

      <div className="form-group">
        <label>Correct Answer</label>
        <select
          value={question.correctAnswer}
          onChange={(e) =>
            setQuestion({ ...question, correctAnswer: e.target.value })
          }
        >
          <option value="">Select Answer</option>
          {["A", "B", "C", "D"].map((choice) => (
            <option key={choice} value={choice}>
              {choice}
            </option>
          ))}
        </select>
      </div>

      <button type="submit" disabled={loading}>
        {loading ? "Saving..." : "Save Question"}
      </button>
    </form>
  );
};

export default Part5Form;
